<template>
  <DefaultLayout :disableFacilitatorTools="true">
    <div style="min-width: 1200px;">
      <h2>{{ $t("title") }}</h2>
      <br />
      <div class="container-fluid">
        <div class="row flex-xl-nowrap2">
          <div
            class="col-4"
          >
            <b-nav vertical>
              <span v-for="tocEntry in getTOC" :key="tocEntry.order_number">
                <b-nav-item active 
                @click="tocClick(tocEntry.order_number)"
                >
                  <span v-if="tocEntry.order_number === order_number">
                    <strong>
                      {{ tocEntry.title }}
                    </strong>
                  </span>
                  <span v-else>
                    {{ tocEntry.title }}
                  </span>
                </b-nav-item>
              </span>
            </b-nav>
          </div>
          <div class="col-8" id="topchapter">
            <div v-for="chapter in getChapters" :key="chapter.id">
              <div
                style="cursor: pointer !important"
                class="btn-link text-primary"
                v-html="chapter.chapter_title"
                @click="chapterClick(chapter.chapter_title)"
              ></div>
            </div>
            <br />
            <div v-for="chapter in getChapters" :key="chapter.id">
              <h4 :id="removeSpaces(chapter.chapter_title)">{{ chapter.chapter_title }}</h4>
              <span>
                <div v-html="chapter.instructions"></div>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </DefaultLayout>
</template>

<script>
import { getFacilitatorInstructions } from "@/services/APIService";
import DefaultLayout from "@/layouts/DefaultLayout.vue";

const sortby = require("lodash.sortby");
const VueScrollTo = require("vue-scrollto");

export default {
  components: { DefaultLayout },
  data() {
    return {
      alertMessage: "",
      instructions: [],
      order_number: 1,
    };
  },
  async mounted() {
    await getFacilitatorInstructions().then((instructions) => {
      this.instructions = instructions;
    });
  },
  watch: {
    getLocale: {
      handler(newData, oldData) {
          this.tocClick(1);
      }
    },
  },
  computed: {
    getLocale() {
      return this.$i18n.locale;
    },    
    getChapters() {
      const chapters = this.instructions.filter(
        (instruction) =>
          instruction.order_number === this.order_number &&
          instruction.locale === this.$i18n.locale
      );

      return sortby(chapters, [
        (o) => {
          return o.sub_order_number;
        },
      ]);
    },
    getTOC() {
      const instructionsInLocale = this.instructions.filter(
        (instruction) =>
          instruction.locale === this.$i18n.locale &&
          instruction.sub_order_number === 1
      );

      return sortby(instructionsInLocale, [
        (o) => {
          return o.order_number;
        },
      ]);
    },
  },
  methods: {
    gamesAdmin() {
      this.$router.push("/admin/games/");
    },
    scroll(title) {
      const titleNoSpaces = this.removeSpaces(title);
      VueScrollTo.scrollTo("#" + titleNoSpaces);
    },
    removeSpaces(string) {
      return string.replace(/\s/g, "");
    },
    tocClick(order_number) {
      this.order_number = order_number;
      VueScrollTo.scrollTo("#topchapter");
    },
    chapterClick(chapter_title) {
      const c = "#" + this.removeSpaces(chapter_title);
      VueScrollTo.scrollTo(c);
    },
  },
};
</script>

<i18n>
  {
    "en": {
      "title": "Facilitator guide"
    },
    "fi": {
      "title": "Pelinjohtajan ohjeet"
    },
    "sv": {
      "title": "Instruktioner för spelledare"
    },
   "de": {
      "title": "Anweisungen für den Moderator"   
    },
    "ko": {
      "title": "퍼실리테이터 가이드"
    }
  }
  </i18n>
